import { RetailerCard } from '../home/RetailerCard'
import { Link } from 'react-router-dom'
import USER_TYPE from '../../constants/userType'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { useQuery } from '@tanstack/react-query'

const TopShopSection = ({ title, userType }) => {
  const { data: wholesellerData } = useQuery({
    queryKey: QueryKeys.topWholesalers(),
    queryFn: () => handleGetRequest('/top-wholesellers'),
    enabled: userType === USER_TYPE.wholeseller,
  })

  const { data: retailersData } = useQuery({
    queryKey: QueryKeys.topRetailers(),
    queryFn: () => handleGetRequest('/top-retailers'),
    enabled: userType === USER_TYPE.retailer,
  })

  const topShopsData = wholesellerData || retailersData
  const topShops = topShopsData?.data || []

  if (topShops.length === 0) {
    return null
  }

  return (
    <div className="bg-background py-2   border-black/50">
      <div className="flex justify-between items-center mb-1 px-4">
        <h2 className="text-lg font-extrabold text-black capitalize">{title}</h2>
      </div>

      <div className="flex overflow-x-auto gap-x-4 scrollbar-hide py-4 pl-4 clip-padding-[0_0_0_1rem]">
        {topShops.map((retailer) => (
          <Link
            to={
              userType === USER_TYPE.wholeseller
                ? `/wholesellers/${retailer.shopSlug}/products`
                : `/retailers/${retailer.shopSlug}/products`
            }
          >
            <RetailerCard key={retailer.shopSlug} retailer={retailer} />
          </Link>
        ))}
        <div className="flex-shrink-0 w-4"></div>
      </div>
    </div>
  )
}

export default TopShopSection
